<template>
  <div>
    <!-- <pre>{{assignment_data_list}}</pre> -->
    <!-- <pre>{{assignment_subjects}}</pre> -->
    <vs-collapse class="new_cstm_collapse_holder">
      <vs-collapse-item
        v-for="(assignment, subject) in assignment_subjects"
        :key="subject"
      >
        <div slot="header">{{ subject }}</div>

        <vs-table
          class="assignment-table cstm_vuexy_table"
          :data="assignment.filter((ele) => ele.curriculum_details)"
        >
          <template slot="header"> </template>
          <br />
          <template slot="thead">
            <vs-th>Name</vs-th>
            <vs-th style="min-width: 150px">Description</vs-th>
            <!-- <vs-th style="min-width: 150px">Type</vs-th>
            <vs-th style="min-width: 150px">Subject</vs-th> -->
            <vs-th style="min-width: 150px">No.of Questions</vs-th>
            <vs-th style="min-width: 104px">No.of Files</vs-th>
            <vs-th>Tags</vs-th>
            <vs-th v-if="edit_permission()">Remove</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <span @click="openPreview(data[indextr])">{{
                  data[indextr].curriculum_details.title
                }}</span>
              </vs-td>

              <vs-td>
                {{ data[indextr].curriculum_details.description }}
              </vs-td>

              <!-- <vs-td>
                {{ data[indextr].curriculum_details.assignment_type }}
              </vs-td>

              <vs-td>
                <span v-if="data[indextr].curriculum_details.subject">{{
                  data[indextr].curriculum_details.subject.subject_name
                }}</span>
              </vs-td> -->

              <vs-td>
                <span v-if="data[indextr].curriculum_details.questions">
                  {{ data[indextr].curriculum_details.questions.length }}
                </span>
              </vs-td>

              <vs-td>
                <span v-if="data[indextr].curriculum_details.questions">
                  <pre>{{ getTotalFiles(data[indextr].curriculum_details.questions) }}</pre>
                </span>
              </vs-td>

              <vs-td>
                <span
                  v-for="(tag, tagindex) in data[indextr].curriculum_details
                    .tags"
                  :key="tagindex"
                >
                  <span v-if="tag && tag.tag">{{ tag.tag.name }}</span>
                  <span
                    v-if="
                      tagindex + 1 <
                      data[indextr].curriculum_details.tags.length
                    "
                    >,
                  </span>
                </span>
              </vs-td>

              <vs-td v-if="edit_permission()">
                <vs-button
                  color="danger"
                  type="border"
                  icon="delete"
                  @click="removeAlert(data[indextr].curriculum_id)"
                ></vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vs-collapse-item>
    </vs-collapse>
  </div>
</template>

<script>
export default {
  props: {
    assignment_data_list: {},
    edit_permission: {
      type: Function
    }
  },
  data () {
    return {
      assignment_subjects: null
    }
  },
  watch: {
    assignment_data_list () {
      console.log('watched')
      this.groupItems()
    }
  },
  mounted () {
    this.groupItems()
  },
  methods: {
    groupItems () {
      //console.log('here', this.assignment_data_list)
      // eslint-disable-next-line no-undef
      this.assignment_subjects = _.groupBy(
        this.assignment_data_list,
        (subject) => subject.curriculum_details.subject.subject_name
      )
      console.log(this.assignment_subjects)
    },
    getTotalFiles (allQuestions) {
      let totalFiles = 0
      allQuestions.map(question => {
        totalFiles += question.files.length
      })

      return totalFiles
    },
    openPreview (assignment) {
      //setTimeout(function(){
      this.$router.push({
        name: 'QuestionsPreview',
        params: {
          assignment_details: assignment.curriculum_details,
          assignmentApplicationType: this.assignmentApplicationType
        }
      })
      //},3000)
    },
    removeAlert (id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: 'Are you sure you want to delete this file?',
        accept: this.acceptAlert,
        parameters: id
      })
    },
    acceptAlert (id) {
      const delete_ids = [id]
      console.log(delete_ids)
      this.$emit('deleteCurricullum', delete_ids)
      console.log(id)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>